import { Autocomplete } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientSelectOptionLabel } from './ClientSelectOptionLabel';
import { useClients } from '../contexts/ClientsContext';
import { buildClientSelectOptions } from '../lib/clientSelectOptions';
import { getClientDisplayName } from '../pages/caseload/data/caseloadUtils';

/**
 * HUD header client search — options from the logged-in user's Medplum caseload (RBAC-scoped).
 */
export function HudClientSearch(): JSX.Element {
  const navigate = useNavigate();
  const { clients, caseloadLoading } = useClients();

  const options = useMemo(
    () =>
      buildClientSelectOptions(
        clients.map((c) => ({
          id: c.id,
          name: getClientDisplayName(c),
          email: c.email,
        })),
      ),
    [clients],
  );

  return (
    <Autocomplete
      placeholder={caseloadLoading ? 'Loading clients…' : 'Search clients...'}
      aria-label="Search clients"
      leftSection={<IconSearch size={18} stroke={1.5} style={{ color: '#9CA3AF' }} />}
      variant="default"
      size="sm"
      radius="md"
      w={320}
      data={options}
      limit={8}
      disabled={caseloadLoading}
      renderOption={({ option }) => (
        <ClientSelectOptionLabel
          label={'label' in option && typeof option.label === 'string' ? option.label : option.value}
        />
      )}
      styles={{
        input: {
          borderColor: '#9CA3AF',
          backgroundColor: '#FFFFFF',
        },
      }}
      onOptionSubmit={(patientId) => {
        if (!patientId) return;
        navigate(`/dashboard/clients/${patientId}`);
      }}
    />
  );
}
